import { http, http1, http2, questionHttp } from './httpClient';
// const home = '/tdzz'
const home = '/ahhpjz/pc'; // 首页测试
// 获取用户信息
export const apiUserQueryUserBasic = () => {
  return http.get(`/v2/user/queryUser`);
};
// export const apiUserQueryUserBasic = () => {
//   return http.get(`/member/info`);
// };
// 登录
export const apiMemberLogin = (params) => {
  return http.post(`/v2/user/login`, params);
};
// 获取图片验证码
export const apiUserQueryVCode = () => {
  return http.get(`/v2/user/queryVCode`);
};
// 用户注册
export const apiMemberRegister = (params) => {
  return http.post(`/v2/user/registered`, params);
};
// 退出登录
export const apiUserLogout = () => {
  return http.get(`/v2/user/logout`, {});
};
// 修改密码
export const apiChangePassward = (params) => {
  return http.post(`/v2/user/updatePassword`, {
    newPassword: params.newPassword,
    oldPassword: params.oldPassword
  });
};
// 修改用户信息
export const apiEditUserInfo = (params) => {
  return http.post(`/v2/user/updateUser`,params);
}
// 上传头像
export const apifileupload = (params) => {
  return http.post(`/v2/userCenter/upload`,params);
}
// 查询用户足迹列表
export const apiqueryVisitHistory = (params) => {
  return http.post(`/v2/userCenter/queryHistoryList`, {
    current: params.current,
    name: '',
    size: params.size,
    timeDistance: params.timeDistance,
    type: ''
  });
};

// 查询用户收藏/点赞列表
// export const apiqueryCollectionList = (params) => {
//   return http.post(`/v2/userCenter/queryFavoriteList`, {
//     current: params.current,
//     name: params.name,
//     size: params.size,
//     timeDistance: params.timeDistance,
//     type: params.type // 类型 0收藏 1点赞
//   });
// };
export const apiqueryCollectionList = (params) => {
  return http.post(`/v2/userCenter/queryAnBoFavoriteList`, {
    current: params.current,
    size: params.size,
    timeDistance: params.timeDistance,
    type: params.type // 类型 0收藏 1点赞
  });
};

// 下载分享的图片
export const downloadInstanceShowImage = (params) => {
  return http.get('/v2/instance/createInstanceShowImage/'+params);
};

// 首页
export const getHome = () => {
  return http1.get(`${home}/json/home.json`);
};
// 关系图谱数据
export const getRelationConfig = () => {
  return http1.get(`${home}/json/recommend.json`);
};
// 列表实例查询
export const InstanceQueryList = (params) => {
  return http.post(`/v2/instance/queryList`, {
    conceptCodes: params.conceptCodes, // 概念代码
    current: params.current,
    instanceName: params.instanceName, // 实例名称
    size: params.size
  });
};
export const queryListQuick = (params) => {
  return http.post(`/v2/absjbsInstance/queryInstanceList`, {
    conceptCodes: params.conceptCodes, // 概念代码
    current: params.current,
    instanceNames: params.instanceNames, // 实例名称
    size: params.size
  });
};
// 古建营造-著作人物
export const querySameTagInstance = (params) => {
  return http.post(`/v2/instance/querySameTagInstance`, {
    conceptCodes: params.conceptCodes, // 这里就根据点的值传conceptCodes
    current: params.current,
    nodeNames: ['古建'], // 这里固定，
    size: params.size
  });
};
// 历代名人列表
export const querySameAttrInstanceQuick = (params) => {
  return http.post(`/v2/instance/querySameAttrInstanceQuick`, {
    attrEnglishCodes: params.attrEnglishCodes,
    conceptCodes: params.conceptCodes,
    current: params.current,
    dictCode: params.dictCode,
    nodeName: params.nodeName,
    size: params.size
  });
};
// 知识百科：顶部横向栏筛选项配置
export const queryValueList = (type) => {
  return http.get(`/v2/instance/queryValueList?type=${type}`);
};

// 知识百科: 左侧栏筛选项配置
export const queryCatList = (params) => {
  return http.post(`/v2/absjbsInstance/queryTagCount`,params);
};

// 实例详情查询
export const queryInstanceDetails = (params) => {
  return http.post(`/v2/absjbsInstance/queryInstanceDetailsV4`, {
    attrEnglishCodes: params.attrEnglishCodes,
    instanceId: params.instanceId
  });
};
// 根据概念code和名称查询实例详情
export const queryInstanceDetailsV3 = (params) => {
  return http.post(`/v2/absjbsInstance/queryInstanceDetailsV3`, {
    conceptCode: params.conceptCode,
    instanceName: params.instanceName
  });
};

// 关联资源接口
export const queryResourceList = (params) => {
  return http.post(`/v2/resource/queryListMarked`, {
    current: params.current,
    fileCategory: params.fileCategory,
    instanceId: params.instanceId,
    size: params.size
  });
};

// 查询相同元素标记
export const querySameElementFileList = (params) => {
  return http.post(`/v2/resource/querySameElementFileList`, {
    current: params.current,
    size: params.size,
    imageMarkId: params.imageMarkId,
    imageMarkName: params.imageMarkName
  });
};

// 查询图谱样式
export const queryStyle = () => {
  // 01 历史建筑群
  return http.get(`/v2/graph/queryStyle`);
};

// 关联资源接口
export const queryAttributes = (params) => {
  return http.post(`/v2/instance/queryCompositeAttributes`, {
    current: params.current,
    size: params.size,
    instanceId: params.instanceId,
    relationshipId: params.relationshipId,
    timeFiledName: params.timeFiledName
  });
};

// 关系实例
export const queryInstanceRel = (params) => {
  return http.post(`/v2/graph/queryInstanceRel`, {
    current: params.current,
    size: params.size,
    conceptCodes: params.conceptCodes,
    nodeId: params.nodeId,
    relationshipName: params.relationshipName,
    relationshipType: params.relationshipType
  });
};

// 嵩阳书院儒生图谱
export const queryRstpList = () => {
  return http.get(`/v2/graph/queryRstpList`);
};

// 嵩阳书院儒生图谱V2关系转节点(tdzz)
export const queryRstpList2 = () => {
  return http.get(`/v2/graph/queryRstpListV2`);
};

// 实例三元组查询
export const queryTriples = (params) => {
  return http.post(`/v2/graph/queryTriples`, {
    depth: params.depth,
    current: params.current,
    size: params.size,
    conceptCodes: params.conceptCodes,
    nodeId: params.nodeId,
    nodeName: params.nodeName,
    relationshipName: params.relationshipName,
    relationshipType: params.relationshipType
  });
};

// 实例三元组查询V2(关系转节点，节点-关系-关系节点-关系-节点)
export const queryTriples2 = (params) => {
  return http.post(`/v2/graph/queryTriplesV2`, {
    depth: params.depth,
    current: params.current,
    size: params.size,
    conceptCodes: params.conceptCodes,
    nodeId: params.nodeId,
    nodeName: params.nodeName,
    relationshipName: params.relationshipName,
    relationshipType: params.relationshipType
  });
};

// 儒生关系查询
export const queryTriplesByAttr = (params) => {
  return http.post(`/v2/graph/queryTriplesByAttr`, {
    depth: params.depth,
    current: params.current,
    size: params.size,
    conceptCodes: params.conceptCodes,
    nodeId: params.nodeId,
    nodeName: params.nodeName,
    relationshipName: params.relationshipName,
    relationshipType: params.relationshipType
  });
};

// 实例三元组查询
export const queryPath = (params) => {
  return http.post(`/v2/graph/queryPath`, params);
};

// 通过参数查询概念标签
export const queryNodeLabel = (params) => {
  const p = new URLSearchParams();
  p.append('instanceId', params.instanceId);
  return http.post(`/api/graphNode/queryNodeLabel`, p);
};

// 实例查询
// export const queryInstanceDetailsV2 = (params) => {
//   const p = new URLSearchParams();
//   p.append('instanceId', params.instanceId);
//   return http.get(`/v2/instance/queryInstanceDetailsV2`, p);
// };
export const queryInstanceDetailsV2 = (params) => {
  return http.get(`/v2/instance/queryInstanceDetailsV2?instanceId=${params.instanceId}`);
};

// 查询实例详细信息
export const queryByInstanceId = (instanceId) => {
  return http.get(`/api/instance/queryByInstanceId/${instanceId}`);
};

// 实例详情查询
export const queryCompositeAttributes = (params) => {
  return http.post(`/v2/instance/queryCompositeAttributes`, {
    current: 1,
    instanceId: params.instanceId,
    params: {},
    relationshipId: 'biography',
    size: 1000,
    timeFiledName: 'sortNum'
  });
};
// 图像检索
export const queryFileInfoList = (params) => {
  return http.post(`/v2/absjbsInstance/queryAnBoFileList`, {
    color: params.color,
    current: params.current,
    fileName: params.fileName,
    searchType: params.searchType, // ：0 默认排序，1最多收藏; 2点赞最多,3标注最多
    size: params.size,
    type: params.type
  });
};
// 图片列表
export const queryPicList = (params) => {
  return http.post(`/v2/resource/queryList`, {
    current: params.current,
    fileCategory: 'FILE_TYPE_PICTURE',
    fileName: params.fileName,
    instanceId: params.instanceId,
    size: params.size
  });
};

// 注：fileCategory为资源类型，有视频也有图片，
// fileCategory = FILE_TYPE_PICTURE  图片
// 只要标记的图列表
export const queryListMarked = (params) => {
  return http.post(`/v2/resource/queryListMarked`, {
    current: params.current,
    fileCategory: 'FILE_TYPE_PICTURE',
    fileName: params.fileName,
    instanceId: params.instanceId,
    size: params.size
  });
};

// 单个图片的所有标注信息接口。
// /v2/resource/queryMarkByFileInfoId/{fileInfoId}
// fileInfoId 为图片文件标识。
export const queryMarkByFileInfoId = (fileInfoId) => {
  return http.get(`/v2/resource/queryMarkByFileInfoId/${fileInfoId}`);
};
// 单个标注的详细信息
// /v2/resource/queryByMarkId/{markId}
// markId为标注标识。
export const queryByMarkId = (markId) => {
  return http.get(`/v2/resource/queryByMarkId/${markId}`);
};
// 影像实例相关推荐查询
export const queryRecommendedImageList = (params) => {
  return http.post(`/v2/resource/queryRecommendedImageList`, {
    conceptCodes: params.conceptCodes,
    current: params.current,
    instanceId: params.instanceId,
    instanceName: params.instanceName,
    size: params.size
  });
};

// 根据实例id查询地理位置
export const queryGeosByInstanceId = (instanceId) => {
  return http.get(`/v2/absjbsInstance/queryAnBoFileInfo/${instanceId}`);
};

// 人物相关的主题建筑景物推荐
export const queryPersonInstanceRelBuilding = (params) => {
  return http.post(`/v2/graph/queryInstanceRel`, {
    conceptCodes: ['AncientBuilding'],
    current: 1,
    nodeId: params.instanceId,
    relationshipType: 'Concept',
    size: 10
  });
};

// 知识问答
export const questionAnswer = (params) => {
  return questionHttp.post(`/api/qa/questionAnswer`, {
    text: params.text
  });
};
// 搜索输入框提示
export const autoComplete = (keyword,indexType,num) => {
  return http2.post(`/v2/search/autoComplete`, {
    keyword: keyword,
    indexType: indexType ? indexType : 0,
    size: num ? num : 5
  });
};
// 知识检索搜索
export const fullTextSearch = (params) => {
  return http2.post(`/v2/search/fullTextSearch`, {
    content: params.content,
    current: params.current,
    size: params.size
  });
};
//  查询搜索词条榜单
export const querySearchTopList = (size) => {
  return http2.get(`/v2/search/querySearchTopList/${size}`);
};
//  知识检索推荐查询
export const queryRecommend = (params) => {
  return http2.post(`/v2/search/queryRecommend`, {
    conceptId: params.conceptId,
    instanceId: params.instanceId
  });
};
// 获取参考文献列表信息
export const queryDocumentList = (params) => {
  return http.get(`/v2/instance/queryDocumentList/${params.current}/${params.size}`);
};

//  查询年表
export const queryChronologyAll = () => {
  return http.get(`/v2/graph/queryChronologyAll`);
};

// 查询实例是否被收藏/点赞
// export const isFavorite = (params) => {
//   return http.get(`/v2/userCenter/isFavorite?instanceId=${params.instanceId}&type=${params.type}`);
// };
export const isFavorite = (params) => {
  return http.post(`/v2/userCenter/isAnBoFavorite`, params);
};
// 收藏或点赞实例
// export const ApiAddFavorite = (params) => {
//   return http.get(`/v2/userCenter/addFavorite?instanceId=${params.instanceId}&type=${params.type}`);
// };
export const ApiAddFavorite = (params) => {
  return http.post(`/v2/userCenter/addAnBoFavorite`,params);
};

// 根据收藏标识取消收藏/点赞
export const apiDelCollection = (relationId) => {
  return http.get(`/v2/userCenter/deleteFavorite?relationId=${relationId}`);
};

// 查询人物生平
export const apiQueryBiography = (instanceId) => {
  return http.get(`/v2/instance/queryBiography?instanceId=${instanceId}`);
};
// 根据关系名称查询复合属性
export const apiQueryCompositeAttrs = (instanceId,relationshipId) => {
  return http.get(`/v2/absjbsInstance/queryBiography?instanceId=${instanceId}&relationshipId=${relationshipId}`);
};
// 热点推荐
export const hotSpot = () => {
  return http1.get(`/tdzz/hot/hotSpot.json`);
};
// 所有人物及第一条地点数据
export const apiQueryAllPersonGeo = () => {
  return http1.get(`/tdzz/json/personGeo.json`)
}
// 关系检索：古建筑、文物、人物推荐
export const relationRecommend = () => {
  return http1.get(`${home}/json/relationRecommend.json`);
};
// 查询概念，conceptId传空时默认查询所有
export const queryConcept = (conceptId) => {
  return http.get(`/v2/ontology/queryConcept?conceptId=${conceptId}`);
};
// 查询所有有创建时间的古建筑的地理位置信息
export const queryGeoPlaceList = (params) => {
  return http.post(`/v2/absjbsInstance/queryGeoPlaceList`, params);
};
// 堂号词云
// 查询所有的堂号及数量
export const queryAnBoTangHao = (params) => {
  return http.post(`/v2/absjbsInstance/queryAnBoTangHao`, params);
};
// 根据堂号名称，查询关联实例信息
export const queryAnBoTangHaoDetails = (params) => {
  return http.post(`/v2/absjbsInstance/queryAnBoTangHaoDetails`, params);
};
// 牌坊金字塔
// 根据属性值及分页参数进行牌坊信息查询
export const queryMemorialList = (params) => {
  return http.post(`/v2/absjbsInstance/queryMemorialList`, params);
};